// src/components/Footer.js
import React, { useEffect } from 'react';
import { loadCSS } from '../utils/cssLoader';

export default function Footer() {
    
    // Load Footer CSS
    useEffect(() => {
        loadCSS('footer.css');
    }, []);
    const year = new Date().getFullYear();
    return (
        <footer className="footer-modern">
            <div className="footer-content-modern">
                <div className="footer-section-modern">
                    <img src="/logo192.webp" alt="Logotipo de Orsan" height="80" style={{marginBottom: '10px'}} />
                    <p className="footer-brand">Inmuebles Orsan</p>
                </div>
                <div className="footer-section-modern">
                    <h4>Enlaces</h4>
                    <ul className="footer-links">
                        <li><a href="/">Inicio</a></li>
                        <li><a href="/properties">Propiedades</a></li>
                        <li><a href="/nosotros">Nosotros</a></li>
                        <li><a href="/contacto">Contacto</a></li>
                    </ul>
                </div>
                <div className="footer-section-modern">
                    <h4>Contáctanos</h4>
                    <a href="mailto:ventas_orsan@hotmail.com" className="footer-contact-link">ventas_orsan@hotmail.com</a>
                    <a href="tel:2283667786" className="footer-contact-link">228 366 7786</a>
                    <div className="footer-socials">
                        <a href="https://www.instagram.com/ventas_orsan?utm_source=qr" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
                            <svg width="32" height="32" viewBox="0 0 24 24">
                                <defs>
                                    <linearGradient id="instagram-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
                                        <stop offset="0%" stopColor="#833ab4"/>
                                        <stop offset="50%" stopColor="#fd1d1d"/>
                                        <stop offset="100%" stopColor="#fcb045"/>
                                    </linearGradient>
                                </defs>
                                <path fill="url(#instagram-gradient)" d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                            </svg>
                        </a>
                        <a href="https://www.facebook.com/inmueblesorsan?mibextid=LQQJ4d&rdid=Gj3M5Db9JHwoO4Jr&share_url=https%3A%2F%2Fwww.facebook.com%2Fshare%2F196Rm5vLPF%2F%3Fmibextid%3DLQQJ4d#" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
                            <svg width="32" height="32" viewBox="0 0 24 24">
                                <path fill="#1877f2" d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                            </svg>
                        </a>
                    </div>
                </div>
                <div className="footer-section-modern">
                    <h4>Sobre Nosotros</h4>
                    <p className="footer-about">
                        Brindamos asesoría integral y<br />
                        soluciones confiables en el<br />
                        sector inmobiliario.
                    </p>
                </div>
            </div>
            <div className="footer-bottom">
                <div className="footer-bottom-content">
                    <div className="footer-bottom-left">
                        <span className="made-with-love">Made with love by NeuroNet</span>
                        <div className="neuronet-logo-space">
                            <img src="/Logo.webp" alt="NeuroNet Logo" style={{width: '100%', height: '100%', objectFit: 'contain'}} />
                        </div>
                    </div>
                    <div className="footer-bottom-center">
                        <span>© {year} Inmuebles Orsan. Todos los derechos reservados.</span>
                    </div>
                </div>
            </div>
        </footer>
    );
}